'use client';

import {
  ButtonProps,
  Flex,
  FlexProps,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import { FC } from 'react';
import colors from '@/constants/theme/colors';
import { CloseLineIcon } from '@/components/Icons';

type FilterBoxProps = FlexProps & {
  isActive?: boolean;
  hideClearIcon?: boolean;
  onClear?: () => void;
};
const FilterBox: FC<FilterBoxProps> = ({
  children,
  isActive,
  hideClearIcon,
  onClear,
  ...flexProps
}) => {
  const handleClearButtonClick: ButtonProps['onClick'] = (ev) => {
    ev.stopPropagation();
    onClear?.();
  };

  return (
    <Flex
      userSelect="none"
      p="0.625rem 1.5rem"
      gap="0.25rem"
      fontSize="0.875rem"
      color={isActive ? colors.white : colors.primary[100]}
      alignItems="center"
      cursor="pointer"
      bgColor={isActive ? colors.primary[100] : 'transparent'}
      border={`1px solid ${
        isActive ? colors.primary[100] : colors.primary[25]
      }`}
      {...flexProps}
    >
      {children}
      {isActive && !hideClearIcon && (
        <Tooltip label="Clear">
          <IconButton
            variant="unstyle"
            aria-label="clear"
            h="fit-content"
            minH="none"
            w="fit-content"
            minW="none"
            icon={<CloseLineIcon size="1.25rem" />}
            onClick={handleClearButtonClick}
          />
        </Tooltip>
      )}
    </Flex>
  );
};

export default FilterBox;
